// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zeUnM","toggle":"styles_toggle__P2gCA","preview":"styles_preview__38Gm9"};